import BaseApi from './BaseApi';
import { IRoleDefinition } from 'src/models/RoleDefinition';

export interface ISaveRoleRequest {
    name: string;
    description?: string;
    isActive: boolean;
    permissionIds: number[];
}

export default class RoleManagement extends BaseApi {
    public getRoles = () => this.getRequest(`${this.baseUrl}v1.0/role-management/roles`);
    public getPermissions = () => this.getRequest(`${this.baseUrl}v1.0/role-management/permissions`);
    public createRole = (role: ISaveRoleRequest) => this.postRequest(`${this.baseUrl}v1.0/role-management/roles`, role);
    public updateRole = (role: IRoleDefinition) => this.putRequest(`${this.baseUrl}v1.0/role-management/roles/${role.id}`, role);
    public getUserRoles = (userId: number) => this.getRequest(`${this.baseUrl}v1.0/role-management/users/${userId}/roles`);
    public setUserRoles = (userId: number, roleIds: number[]) =>
        this.putRequest(`${this.baseUrl}v1.0/role-management/users/${userId}/roles`, { roleIds });
}



// WEBPACK FOOTER //
// ./src/api/RoleManagement.ts